import { render, staticRenderFns } from "./SaveDesignModal.vue?vue&type=template&id=47072b35"
import script from "./SaveDesignModal.vue?vue&type=script&lang=js"
export * from "./SaveDesignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports